import { styled } from '@mui/material/styles';

import { PRIMARY_COLORS } from '../../../themes/light';

export const AmenitiesSubtitle = styled('div')`
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #1a1a1a;

  &:nth-child(1) {
    font-weight: 600;
  }
`;

export const AmenityName = styled(AmenitiesSubtitle)``;

export const SnackBarContainer = styled('div')`
  position: relative;
  & .snackBarBlock {
    position: fixed;
    left: 50%;
    bottom: 15px;
    transform: translate(-50%);
  }
`;

export const CheckboxContainer = styled('div')`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${(p) => p.theme.spacing(2)};

  & div:first-child > div:nth-child(2) {
    font-weight: 600;
  }
`;

export const ImageWrapperContainer = styled('div')`
  display: grid;
`;

export const ClosedModalButton = styled('div')`
  padding: 0;
  margin: 0;
  border: none;
  outline: none;
  cursor: pointer;
  display: flex;
`;

// For Image upload

export const UploadedImagesContainer = styled('div')`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 10px;
  margin-bottom: 15px;
  margin-top: 15px;
  z-index: 10;
`;

export const OnDragOverBlock = styled('div')`
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(26, 26, 26, 0.46);
  top: 0;
  left: 0;
  z-index: 20000;
`;

export const OnDragOverBlockBorder = styled('div')`
  position: absolute;
  border: 3px dashed #e3e3e3;
  width: calc(100% - 50px);
  height: calc(100% - 50px);
  left: 25px;
  top: 25px;
`;

export const OnDragOverBlockText = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  font-style: normal;
  font-weight: 400;
  font-size: 34px;
  line-height: 40px;
  color: #ffffff;
  transform: translate(-50%, -50%);
`;

export const addBtnStyles = {
  backgroundColor: PRIMARY_COLORS.ALT_PRIMARY_COLOR,
  '&:hover': { backgroundColor: PRIMARY_COLORS.ALT_PRIMARY_HOVER_COLOR },
};
